"use client";

import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
const _excluded = ["date"];
var __jsx = React.createElement;
import React, { useEffect, useMemo } from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import 'styles/hacks/react-date-picker-hack.css';
import { useTranslations } from 'next-intl';
import { es } from "date-fns/locale";
import CalendarDayContent from '../../calendar-day-content';
import { MODIFIER_CALENDAR_CLASS_NAMES } from '@lib/constants';
import { getModifiers } from '@lib/util/range-picker-ops';
import { datesAreEqual } from '@lib/util/date-ops';
import CalendarCaption from '../../calendar-caption';
const MuscleSingleDateCalendar = _ref => {
  let {
    onSelect,
    value,
    minDate,
    maxDate,
    prices,
    onMonthChange,
    isMobile = false
  } = _ref;
  const t = useTranslations();
  const [selected, setSelected] = React.useState(value);
  useEffect(() => {
    setSelected(value);
  }, [value]);
  const {
    modifiers,
    defaultMonth
  } = useMemo(() => {
    const currentDate = new Date();
    let defaultDisplayMonth = selected || currentDate;

    // If no selection and minDate is after current date, use minDate
    if (!selected && minDate && minDate > currentDate) {
      defaultDisplayMonth = minDate;
    }
    return {
      modifiers: getModifiers(prices),
      defaultMonth: defaultDisplayMonth
    };
  }, [prices, selected, minDate]);
  const handleSelection = selection => {
    setSelected(selection);
    onSelect(selection);
  };
  return __jsx("div", {
    className: "text-black w-full ".concat(isMobile ? 'rdp-mobile-full-width' : '')
  }, __jsx(DayPicker, {
    disabled: minDate ? {
      before: minDate,
      after: maxDate
    } : undefined,
    mode: "single",
    numberOfMonths: isMobile ? 1 : 2,
    selected: selected,
    onMonthChange: onMonthChange,
    onSelect: handleSelection,
    defaultMonth: defaultMonth,
    fixedWeeks: false,
    locale: es,
    modifiers: modifiers,
    modifiersClassNames: MODIFIER_CALENDAR_CLASS_NAMES,
    components: {
      Caption: props => __jsx(CalendarCaption, _extends({}, props, {
        monthsQuantity: isMobile ? 1 : 2
      })),
      DayContent: _ref2 => {
        var _prices$find;
        let {
            date
          } = _ref2,
          props = _objectWithoutProperties(_ref2, _excluded);
        return __jsx(CalendarDayContent, _extends({
          date: date,
          price: prices === null || prices === void 0 || (_prices$find = prices.find(p => datesAreEqual(p.date, date))) === null || _prices$find === void 0 ? void 0 : _prices$find.price
        }, props));
      }
    }
  }));
};
export default MuscleSingleDateCalendar;